import Tracker from '@openreplay/tracker';

export class OpenReplayService {
  tracker;

  constructor() {
    this.tracker = new Tracker({
      projectKey: process.env.REACT_APP_OPEN_REPLAY_KEY,
      ingestPoint: 'https://openreplay.buyproperly.com/ingest',
    });
  }

  start() {
    return this.tracker.start();
  }

  setUserData({ email, userFullName }) {
    this.tracker?.setUserID(email);
    this.tracker?.setMetadata('displayName', userFullName);
  }
}
